import { render, staticRenderFns } from "./1003.vue?vue&type=template&id=c59d43ac&scoped=true&"
import script from "./1003.vue?vue&type=script&lang=js&"
export * from "./1003.vue?vue&type=script&lang=js&"
import style0 from "./1003.vue?vue&type=style&index=0&id=c59d43ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d43ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
